/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCompareText } from '../../factoriesAny.js';
export var compareTextDependencies = {
  matrixDependencies,
  typedDependencies,
  createCompareText
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCompareText.generated.js
// module id = 529
// module chunks = 2